import React, { useRef, useState } from 'react';
import Select from 'react-select';
import ENUMS from '../../../enums';

const CafeDiscountRequestsFilter = props => {
  const formRefrence = useRef();
  const [namePart, setNamePart] = useState('');
  const [selectedStatusCheckbox, setSelectedStatusCheckbox] = useState([]);
  const [cafeIds, setCafeIds] = useState([]);
  const [filters, setFilters] = useState({});

  const onChangeNamePart = event => {
    const { value } = event.target;
    let clonedFilters = { ...filters };
    clonedFilters.namePart = {
      operator: 'like',
      value
    };

    setNamePart(value);
    setFilters(clonedFilters);
  };

  // const onChangeCafeIds = selectedCafeIds => {
  //   let clonedFilters = { ...filters };
  //   clonedFilters.cafeIds = {
  //     operator: 'contains',
  //     value: selectedCafeIds.map(x => x.value).join(',')
  //   };

  //   props.onSelectCafeIds(selectedCafeIds);
  //   setCafeIds(selectedCafeIds);
  //   setFilters(clonedFilters);
  // };

  const onChangeCafeIds = selectedCafeIds => {
    setCafeIds(selectedCafeIds);
    props.onSelectCafeIds(selectedCafeIds);
  };

  const onChangeStatus = event => {
    let clonedFilters = { ...filters };
    if (event.target.checked) {
      clonedFilters.status = clonedFilters.status || [];
      clonedFilters.status.push({ operator: 'eq', or: true, value: event.target.value });
    } else {
      clonedFilters.status = clonedFilters.status.filter(s => s.value !== event.target.value);
    }
    setFilters(clonedFilters);
  };

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeIds([]);
    props.onSelectCafeIds([]);
    setNamePart();
    setSelectedStatusCheckbox(null);
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => {
          props.applyFilters(event);
        }}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex col-12 justidy-content-between px-1">
            <div className="d-flex flex-column mx-1 col-5 h-50">
              <input
                onChange={onChangeNamePart}
                value={namePart}
                name="namePart"
                type="text"
                className="form-control col-12"
                placeholder={locales('tables.title')}
                maxLength={ENUMS.MAX_LENGTH.title}
              />
              <small style={{ color: '#ccc' }}>{locales('maxLength.20')}</small>
            </div>
            <div className="d-flex flex-column mx-1 col-5 h-50">
              <Select
                id="cafeIds"
                name="cafeIds"
                isMulti={true}
                value={cafeIds}
                onChange={onChangeCafeIds}
                className="col-12"
                options={props.cafeNamesList.map(n => ({
                  label: n.name,
                  value: n.id
                }))}
                placeholder={locales('fields.cafe.name')}
              />
            </div>
          </div>

          <div className="d-flex col-12 justify-content-end mx-1 py-2 my-2">
            <span className="col-2 text-center d-flex align-items-center">{locales('tables.status')} : </span>
            <div className="col-10 p-0 d-flex justify-content-center align-items-center">
              {ENUMS.EVENT_STATUS.list.map((bankStatus, index) => (
                <div className={`col-3 d-flex p-0`} key={index}>
                  <input
                    type="checkbox"
                    value={bankStatus.value}
                    name={`status`}
                    id={`status-${index}`}
                    className="my-2"
                    onChange={onChangeStatus}
                  />
                  <label className="my-2 mx-1" htmlFor={`status-${index}`}>
                    {bankStatus.title}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-cafeEvent" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default CafeDiscountRequestsFilter;
